import {gsap} from "gsap";
import {tweens_arrays_apparition as tween_big_title} from '../../../miscellaneous/bigTitle'
import {init_home_slider, timeline as timeline_slider} from '../../../home/slider'

const homeAnimationEnter = (container) => {
    console.log("animation enter de la home");

    timeline_slider.seek(0);
    timeline_slider.resume();

    init_home_slider();

    const section_w1 = $("#h-scroll-wrapper section.w1")
    const menu = $(container).find("#nav-wrapper").first();

    gsap.set([section_w1, menu], {autoAlpha:0})
    const tl = gsap.timeline({
        delay:0,
        defaults : {
            duration: .6,
            ease: "power1.out",
        }
    });
    let page_title = $(container).find("#page-title").first();
    tl.add(tween_big_title)
        .to(section_w1, {autoAlpha:1}, '-=0.5')
        .to([page_title, menu], {autoAlpha:1}, '-=1')
        .add(timeline_slider, '-=0.5');
    // tl.timeScale(5);
    return tl;

}

export default homeAnimationEnter;